import { Locale } from 'date-fns'
import { enUS, es, it, pt } from 'date-fns/locale'

import { LANGUAGES } from './languages'

export const LOCALES: Record<(typeof LANGUAGES)[number], Locale> = {
  pt: pt,
  'pt-BR': pt,
  en: enUS,
  'en-US': enUS,
  es: es,
  'es-ES': es,
  it: it,
}
